import { combineReducers } from '@reduxjs/toolkit'
import { reducer as formReducer } from 'redux-form'
import fillterValueReducer from './filter-forms-reducers'

const reducers = combineReducers({
  form: formReducer,
  filter: fillterValueReducer,
})

export default reducers

